import UbahPurchaseRequest from './UbahPurchaseRequest'

export default UbahPurchaseRequest